<div>
    <app-icon ic="IcEditPen" size="s" color="var(--color-primary-60)" (click)="editBtnAction()"></app-icon>
</div>
